import { render } from "./SSOAdd.vue?vue&type=template&id=37e9382a"
import script from "./SSOAdd.vue?vue&type=script&lang=js"
export * from "./SSOAdd.vue?vue&type=script&lang=js"

import "./SSOAdd.vue?vue&type=style&index=0&id=37e9382a&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__